import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { ProductModulesBody } from "../productModulesBody";

/**
 * sealy ProductLinePage `modules` body assembly (#33590); see
 * `productModulesBody.tsx` for the dispatch map and side-channel design.
 *
 * FAITHFUL port of the legacy `cms/product_line_page.html` body loop (verified
 * at git dev): `{% for block in self.modules %}{% if block.block_type !=
 * "gallery_block" %}{% include_block block %}{% endif %}{% endfor %}` -- only
 * top-level `gallery_block` is filtered, reproduced by the `.filter()` below.
 * The legacy `{% cache 300 pdp_modules ... %}` fragment caching lives on as
 * `ProductLinePage._cached_fragment_data`, which caches the side-channel
 * builder outputs under the same key parts. `configurator_based_modules` is
 * OUT of scope (configurator-segment-served; never rendered by this
 * template).
 */
export const ProductLinePageBody = (
    props: Immutable<
        Pick<
            templates.ProductLinePageTemplate,
            | "page"
            | "reviews"
            | "page_num_reviews"
            | "change_variant_ssr"
            | "change_root_ssr"
            | "root_conditional_ssr"
            | "variant_conditional_ssr"
            | "tab_cards_initial_root_product_id"
        >
    >,
): React.JSX.Element | null => {
    const modules = props.page.modules;
    if (!modules) {
        return null;
    }
    return (
        <ProductModulesBody
            value={modules.value.filter(
                (block) => block.type !== "gallery_block",
            )}
            reviews={props.reviews}
            pageNumReviews={props.page_num_reviews}
            changeVariantSSR={props.change_variant_ssr}
            changeRootSSR={props.change_root_ssr}
            rootConditionalSSR={props.root_conditional_ssr}
            variantConditionalSSR={props.variant_conditional_ssr}
            tabCardsInitialRootProductID={
                props.tab_cards_initial_root_product_id
            }
        />
    );
};
